import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactPaginate from 'react-paginate';
import queryString from 'query-string';

import CreditNoteTable from '../../components/creditNotes/CreditNoteList';
import Spinner from '../../components/generics/Spinner';
import ListHeader from '../../components/generics/ListHeader';
import Filter from '../../components/generics/Filter';
import _ from 'lodash';

import { STARTING_PAGE } from '../../constants/constants';

import { fetchVendors, fetchVendorsSuccess, fetchVendorsFailure } from "../../store/invoices/actions";
import { fetchCreditNotes, fetchCreditNotesSuccess, fetchCreditNotesFailure } from "../../store/creditNotes/actions";
import { withRouter } from "utils/WithRouter";

export class CreditNoteListContainer extends Component {
  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      invoiceNumber: '',
      creditNoteNumber: '',
      creditNoteDate: '',
      vendor: undefined
    }
    this.debounceSearch = _.debounce(this.filterList, 300);
  }

  componentDidMount(){
    const params = queryString.parse(this.props.location.search);
    const creditNoteDate = params.date ? params.date : '';
    const invoiceNumber = params.invoice ? params.invoice : '';
    const creditNoteNumber = params.creditnote ? params.creditnote : '';
    const vendor = params.vendor ? params.vendor : undefined;
    const page = params.page ? params.page : STARTING_PAGE;
    // this.setState({ page}, () => {
    //   this.props.fetchCreditNotes(page);
    // });
    this.setState({ page, invoiceNumber, creditNoteNumber, creditNoteDate, vendor }, () => {
      this.props.fetchCreditNotes(page, invoiceNumber, creditNoteNumber, creditNoteDate, vendor);
    });
    if (this.props.vendorsList.vendors.length === 0){
      this.props.fetchVendors();
    }
  }

  // ---------------------------------------------------------------------------
  // Filters
  // ---------------------------------------------------------------------------
  onDateChange = (event) => {
    let creditNoteDate = event.target.value ? event.target.value : '';
    this.setState({ creditNoteDate, page: STARTING_PAGE }, () => {
      this.filterList();
    });
  };

  onInvoiceNumberChange = (event) => {
    let invoiceNumber = event.target ? event.target.value : '';
    this.setState({ invoiceNumber, page: STARTING_PAGE }, () => {
      this.debounceSearch();
    });
  };

  onCreditNoteNumberChange = (event) => {
    let creditNoteNumber = event.target ? event.target.value : '';
    this.setState({ creditNoteNumber, page: STARTING_PAGE }, () => {
      this.debounceSearch();
    });
  };

  onVendorChange = (event) => {
    let vendor = event.target.value && event.target.value > -1 ? event.target.value : undefined;
    this.setState({ vendor, page: STARTING_PAGE }, () => {
      this.filterList();
    });
  };

  filterList = () => {
    let params = {};
    if (this.state.invoiceNumber){
      params.invoice = this.state.invoiceNumber;
    }
    if (this.state.creditNoteNumber) {
      params.creditnote = this.state.creditNoteNumber;
    }
    if (this.state.creditNoteDate){
      params.date = this.state.creditNoteDate;
    }
    if (this.state.vendor){
      params.vendor = this.state.vendor;
    }
    params.page = this.state.page;
    this.props.history.push({
      search: queryString.stringify(params)
    });
    this.props.fetchCreditNotes(this.state.page,
                             this.state.invoiceNumber,
                             this.state.creditNoteNumber,
                             this.state.creditNoteDate,
                             this.state.vendor);
  };

  // ---------------------------------------------------------------------------
  // Pagination
  // ---------------------------------------------------------------------------
  handlePageRequest = (data) => {
    let page = data.selected + 1;
    if(page !== this.state.page){
      this.setState({ page }, () => {
          this.filterList();
      });
    };
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render() {
    if(!this.props.creditNoteList.creditNotes){
      return(
        <Spinner />
      )
    }
    return (
      <div className="animated fadeIn">
        <div className="card">
          <ListHeader title="Credit Notes"
                      iconClass="fa fa-arrow-circle-right mr-05"
                      actionLink={'/invoice'} />

          <Filter
            searchLabel="Invoice Number"
            searchPlaceholder="Invoice number"
            searchVal={this.state.invoiceNumber}
            onSearchChange={this.onInvoiceNumberChange}
            searchLabel2="Credit Note Number"
            searchPlaceholder2="Credit Note number"
            searchVal2={this.state.creditNoteNumber}
            onSearchChange2={this.onCreditNoteNumberChange}
            dateLabel="Credit Note Date"
            dateVal={this.state.creditNoteDate}
            onDateChange={this.onDateChange}
            dropdownLabel="Vendor"
            dropdownPlaceholder="Select vendor"
            dropdownVal={this.state.vendor}
            onDropdownChange={this.onVendorChange}
            dropdownByElementId
            dropdownOptions={this.props.vendorsList.vendors.results}
            colClass="col-12 col-sm-3"
          />
        </div>
        <div className="card">
          <div className="card-block p-0">
            <CreditNoteTable list={this.props.creditNoteList.creditNotes}  />

            {this.props.creditNoteList.pages > 1 &&
              <ReactPaginate pageCount={this.props.creditNoteList.pages}
                             pageRangeDisplayed={2}
                             marginPagesDisplayed={1}
                             previousLabel="<"
                             nextLabel=">"
                             onPageChange={this.handlePageRequest}
                             initialPage={this.state.page-1}
                             disableInitialCallback={true}
                             containerClassName="pagination"
                             pageClassName="page-item"
                             pageLinkClassName="page-link"
                             activeClassName="page-item active"
                             previousClassName="paginate_button previous"
                             nextClassName="paginate_button next"
                             disabledClassName="page-item disabled"
                             forcePage={this.state.page-1}/>
            }
          </div>
        </div>
        {this.props.creditNoteList.loading ?
          <Spinner />
        :
          null
        }
      </div>
    );
  }
};

const mapStateToProps = (state, ownProps) => {
  return {
    creditNoteList: state.creditNotes.creditNoteList,
    vendorsList: state.invoices.vendorsList
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchCreditNotes: (page, invoiceNumber, creditNoteNumber, creditNoteDate, vendor) => {
      dispatch(fetchCreditNotes(page, invoiceNumber, creditNoteNumber, creditNoteDate, vendor)).payload.then((response) => {
        dispatch(fetchCreditNotesSuccess(response.data))
      }, (error) => {
        dispatch(fetchCreditNotesFailure(error));
      });
    },
    fetchVendors: (props) => {
      dispatch(fetchVendors()).payload.then((response) => {
        dispatch(fetchVendorsSuccess(response.data))
      }, (error) => {
        dispatch(fetchVendorsFailure(error));
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CreditNoteListContainer));
